import { render, staticRenderFns } from "./WaterMeterInfoTabs.vue?vue&type=template&id=73a1ac7a"
import script from "./WaterMeterInfoTabs.vue?vue&type=script&lang=ts"
export * from "./WaterMeterInfoTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports